import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, message, Spin } from "antd";
import { ajax } from "../utils/request";
import { useLocation, useNavigate } from "react-router-dom";

function ResetPassword() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const navigate = useNavigate();

  // Get the token from the URL query parameters
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  // Check for the token when the component loads
  useEffect(() => {
    if (!token) {
      messageApi.error("Password reset token is missing.");
    }
  }, [token, messageApi]);

  const onFinish = async (values) => {
    // Check if passwords match before making the API call
    if (values.new_password !== values.confirm_password) {
      messageApi.error("The two passwords that you entered do not match!");
      return;
    }

    setLoading(true);
    try {
      const res = await ajax.patch("/user/reset-password", {
        token: token,
        new_password: values.new_password,
      });

      if (res.data.code === 0) {
        messageApi.success("Your password has been reset successfully. You can now log in.");
        setTimeout(() => {
          navigate("/"); // Redirect to the homepage or login page
        }, 2000);
      } else {
        messageApi.error(res.data.detail || "Failed to reset password.");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.detail) {
        messageApi.error(err.response.data.detail);
      } else {
        messageApi.error("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const passwordRules = [
    { required: true, message: "Please input your new password!" },
    { min: 6, message: "Password must be at least 6 characters long." },
    { max: 18, message: "Password must be between 6 and 18 characters long." },
  ];

  if (!token) {
    return (
      <Card style={{ margin: "50px auto", maxWidth: "400px", textAlign: "center" }}>
        <p>Password reset link is invalid or expired. Please request a new one.</p>
      </Card>
    );
  }

  return (
    <div style={{ padding: "20px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
      {contextHolder}
      <Card title="Reset Password" style={{ width: 400 }}>
        <Form
          form={form}
          name="reset_password_form"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="New Password"
            name="new_password"
            rules={passwordRules}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirm New Password"
            name="confirm_password"
            dependencies={["new_password"]}
            hasFeedback
            rules={[
              ...passwordRules,
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The two passwords that you entered do not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default ResetPassword;